module.exports = __webpack_public_path__ + "static/media/pin.629638a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/third-party/GoogleMap/pin.svg
// module id = 816
// module chunks = 0 1 2 3 15 17